const SET_TAB = 'SET_TAB';
const SUPER_OFFERS = 'SUPER_OFFERS';
const APPLY_TO = 'APPLY_TO';
const DAILY_SPECIALS = 'DAILY_SPECIALS';

const setTab = ({ activeTab }) => ({
  type: SET_TAB,
  activeTab
});

export {
  SET_TAB, SUPER_OFFERS, APPLY_TO, DAILY_SPECIALS, setTab
};
